module.exports = __webpack_public_path__ + "media/game_final.d4576399.mp3";